module.exports = __webpack_public_path__ + "img/icon1.7d0a9ea4.png";